import React, { useState, useEffect } from 'react';
import './sideBar.css';
import {
  clearManualStockList,
  clearHinNumber,
  clearIsFetch,
  clearIsFetchExist,
  clearIsFetchStrategy,
  clearIsMatchFound,
  clearManualEntryVisible,
  clearPortfolioList,
  clearStockList,
  clearRequestId,
} from '../../Redux/store/inspecie-transfer';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

function Sidebar({ isMobile, toggleMenu, isMenuOpen, onSideMenupChange }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const roleName = useSelector((state) => state.user.roleName);
  const isBusinessOwner = useSelector((s) => s.user.isBusinessOwner);

  const hasPendingTraining = useSelector(
    (state) => state.user.hasPendingTraining,
  );
  useEffect(() => {
    let pathToMenuId = {};
    if (roleName == 'customer') {
      pathToMenuId = {
        '/': 1,
        '/my-profile': 2,
        '/support-tickets': 3,
      };
    }
    if (roleName == 'agency' && isBusinessOwner) {
      pathToMenuId = {
        '/': 1,
        '/my-profile': 2,
        '/customer-list': 3,
        '/compliance-officer': 5,
        '/support-tickets': 8,
        '/my-pricing-plan': 10,
        '/auditor-list': 11,
        '/role-permission-settings': 12,
        '/certificates': 13,
        '/members': 14,
      };
    }
    if (roleName == 'agency' && !isBusinessOwner) {
      pathToMenuId = {
        '/': 1,
        '/my-profile': 2,
        '/customer-list': 3,
        '/compliance-officer': 5,
        '/support-tickets': 8,
        '/my-pricing-plan': 10,
        '/auditor-list': 11,
        '/role-permission-settings': 12,
        '/certificates': 13,
      };
    }
    if (roleName == 'agency_compliance') {
      pathToMenuId = {
        '/': 1,
        '/my-profile': 2,
        '/team-member-list': 3,
        '/customer-list': 4,
        '/support-tickets': 9,
      };
    }
    if (roleName == 'auditor') {
      pathToMenuId = {
        '/': 1,
        '/my-profile': 2,
        '/team-member-list': 3,
        '/customer-list': 4,
        '/compliance-officer': 5,
        '/support-tickets': 9,
      };
    }
    if (roleName == 'business') {
      pathToMenuId = {
        '/': 1,
        '/my-profile': 2,
        '/customer-list': 3,
        '/business-owner-list': 4,
        '/support-tickets': 5,
      };
    }
    if (roleName == 'agent') {
      pathToMenuId = {
        '/': 1,
        '/my-profile': 2,
        '/customer-list': 3,
        '/support-tickets': 5,
      };
    }
    const currentMenuId = pathToMenuId[location.pathname];
    if (currentMenuId) {
      setSelectedItem(currentMenuId);
      localStorage.setItem('sideOption', currentMenuId);
    }
  }, [location.pathname]);

  // Close drawer with Escape key on mobile
  useEffect(() => {
    if (!isMobile || !isMenuOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') toggleMenu();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isMobile, isMenuOpen]);

  const handleChange = () => {
    localStorage.setItem('billingFilter', 'spend');

    toggleMenu();
  };
  const trainingMenuIds = {
    agency_compliance: 7,
    agent: 4,
  };
  let menuItems = [];
  if (roleName == 'customer') {
    menuItems = [
      {
        id: 1,
        label: 'Certificate',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: 'dashboard',
      },
      {
        id: 2,
        label: 'My Profile',
        defaultIcon: '/profile-black.svg',
        selectedIcon: '/profile-white.svg',
        icon: '',
      },
      {
        id: 3,
        label: 'My Requests',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'headphones',
      },
    ];
  }
  if (roleName == 'agency' && isBusinessOwner) {
    menuItems = [
      {
        id: 1,
        label: 'Dashboard',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: 'dashboard',
      },
      {
        id: 2,
        label: 'My Business',
        defaultIcon: '/profile-black.svg',
        selectedIcon: '/profile-white.svg',
        icon: 'business',
      },
      {
        id: 3,
        label: 'Customers',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: 'manage_accounts',
      },
      // -- nested under Settings --
      {
        id: 10,
        label: 'Usage',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'credit_card',
      },
      {
        id: 8,
        label: 'Support',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'headphones',
      },
      {
        id: 13,
        label: 'Certificates',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'description',
      },
      {
        id: 14,
        label: 'Members',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'group',
      },
    ];
  }
  if (roleName == 'agency' && !isBusinessOwner) {
    menuItems = [
      {
        id: 1,
        label: 'Dashboard',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: 'dashboard',
      },
      {
        id: 2,
        label: 'My Business',
        defaultIcon: '/profile-black.svg',
        selectedIcon: '/profile-white.svg',
        icon: 'business',
      },
      {
        id: 3,
        label: 'Customers',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: 'manage_accounts',
      },
      // -- nested under Settings --
      {
        id: 10,
        label: 'Usage',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'credit_card',
      },
      {
        id: 8,
        label: 'Support',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'headphones',
      },
      {
        id: 13,
        label: 'Certificates',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'description',
      },
    ];
  }
  const isLocked = (itemId) => {
    if (hasPendingTraining == false || hasPendingTraining == 'false')
      return false;
    const trainingId = trainingMenuIds[roleName];
    return true;
  };
  if (roleName == 'agency_compliance') {
    menuItems = [
      {
        id: 1,
        label: 'Dashboard',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: '',
      },
      {
        id: 2,
        label: 'My Profile',
        defaultIcon: '/profile-black.svg',
        selectedIcon: '/profile-white.svg',
        icon: '',
      },
      {
        id: 3,
        label: 'Team Members',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: 'manage_accounts',
      },
      {
        id: 4,
        label: 'Customers',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: '',
      },
      {
        id: 9,
        label: 'My Requests',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'headphones',
      },
    ];
  }
  if (roleName == 'auditor') {
    menuItems = [
      {
        id: 1,
        label: 'Dashboard',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: '',
      },
      {
        id: 2,
        label: 'My Profile',
        defaultIcon: '/profile-black.svg',
        selectedIcon: '/profile-white.svg',
        icon: '',
      },
      {
        id: 3,
        label: 'Team Members',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: 'manage_accounts',
      },
      {
        id: 4,
        label: 'Customers',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: '',
      },
      {
        id: 5,
        label: 'Compliance Officer',
        defaultIcon: '/compliance-black.svg',
        selectedIcon: '/compliance-white.svg',
        icon: 'manage_accounts',
      },
      {
        id: 9,
        label: 'My Requests',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'headphones',
      },
    ];
  }
  if (roleName == 'business') {
    menuItems = [
      {
        id: 1,
        label: 'Dashboard',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: '',
      },
      {
        id: 2,
        label: 'My Business',
        defaultIcon: '/profile-black.svg',
        selectedIcon: '/profile-white.svg',
        icon: '',
      },
      {
        id: 3,
        label: 'Customers',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: '',
      },
      {
        id: 4,
        label: 'Agencies',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'manage_accounts',
      },
      {
        id: 5,
        label: 'My Requests',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'headphones',
      },
    ];
  }
  if (roleName == 'agent') {
    menuItems = [
      {
        id: 1,
        label: 'Dashboard',
        defaultIcon: '/dashboard-black.svg',
        selectedIcon: '/element-dashboard.svg',
        icon: '',
      },
      {
        id: 2,
        label: 'My Profile',
        defaultIcon: '/profile-black.svg',
        selectedIcon: '/profile-white.svg',
        icon: '',
      },
      {
        id: 3,
        label: 'Customers',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: '',
      },
      {
        id: 5,
        label: 'My Requests',
        defaultIcon: '/customer-black.svg',
        selectedIcon: '/profile-2user.svg',
        icon: 'headphones',
      },
    ];
  }
  const [selectedItem, setSelectedItem] = useState(
    Number(localStorage.getItem('sideOption')) || 1,
  );
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isSettingsExpanded, setIsSettingsExpanded] = useState(() =>
    [2, 8, 9, 10, 14].includes(Number(localStorage.getItem('sideOption'))),
  );

  // Top-level items shown flat; the rest nest under the Settings accordion.
  const settingsIds = [2, 8, 9, 10, 14];
  const topLevelIds = [1, 3, 13];
  const topLevelItems = menuItems.filter((i) => topLevelIds.includes(i.id));
  const settingsItems = menuItems.filter((i) => settingsIds.includes(i.id));

  const isFlatRole = roleName !== 'agency';

  const handleChangeMenu = (id) => {
    localStorage.setItem('sideOption', Number(id));
    localStorage.setItem('billingFilter', 'spend');

    if (id === 5) {
      dispatch(clearHinNumber());
      dispatch(clearManualStockList());
      dispatch(clearIsFetch());
      dispatch(clearIsFetchExist());
      dispatch(clearIsFetchStrategy());
      dispatch(clearIsMatchFound());
      dispatch(clearManualEntryVisible());
      dispatch(clearPortfolioList());
      dispatch(clearStockList());
      dispatch(clearRequestId());
    }
    setSelectedItem(id);
    onSideMenupChange(id);
    toggleMenu();
  };

  const [isImageLoaded, setImageLoaded] = React.useState(false);

  const renderItem = (item) => (
    <SidebarItem
      key={item.id}
      item={item}
      selectedItem={selectedItem}
      hoveredItem={hoveredItem}
      setHoveredItem={setHoveredItem}
      handleChangeMenu={handleChangeMenu}
    />
  );

  return (
    <div
      className={`
    ${
      isMobile
        ? `fixed top-0 left-0 z-10 h-[100dvh] w-[82vw] max-w-[300px] bg-white shadow-2xl rounded-r-2xl
           transform transition-transform duration-300 ease-out will-change-transform
           ${isMenuOpen ? 'translate-x-0' : '-translate-x-full pointer-events-none'}`
        : 'text-black sticky top-0 left-0 h-screen shrink-0 w-[240px] xl:w-[260px] 2xl:w-[18vw]'
    }`}
      aria-hidden={isMobile && !isMenuOpen}
      role={isMobile ? 'dialog' : undefined}
      aria-modal={isMobile ? true : undefined}
      aria-label={isMobile ? 'Main menu' : undefined}
    >
      <div
        className={`relative flex flex-col h-full w-full ${
          isMobile
            ? 'pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]'
            : ''
        }`}
      >
        {/* Company Logo */}
        <div
          className={`pr-4 pl-4 flex flex-col shrink-0 ${
            isMobile ? 'border-b border-gray-100' : ''
          }`}
        >
          <div className="relative w-auto h-20 flex items-center justify-between gap-2">
            <div
              className={`absolute inset-0 bg-gray-200 animate-pulse ${
                isImageLoaded ? 'hidden' : 'block'
              }`}
            ></div>
            <img
              src="/Ratified-Logo-Main.svg"
              alt="Company Logo"
              className={`w-32 sm:w-40 ${isImageLoaded ? 'block' : 'hidden'}`}
              onLoad={() =>
                setTimeout(function () {
                  setImageLoaded(true);
                }, 100)
              }
            />
            {isMobile && isMenuOpen && (
              <button
                type="button"
                onClick={handleChange}
                aria-label="Close menu"
                className="relative z-10 h-10 w-10 shrink-0 flex items-center justify-center rounded-full bg-gray-100 text-gray-700 hover:bg-gray-200 active:scale-95 transition"
              >
                <span className="material-symbols-outlined text-[22px] leading-none">
                  close
                </span>
              </button>
            )}
          </div>
        </div>

        {/* Menu List */}
        {isImageLoaded && (
          <nav
            className={`sidebar-navigation flex-1 min-h-0 overflow-y-auto overscroll-contain ${
              isMobile
                ? [
                    'px-3 py-3 w-full',
                    // Neutralise desktop-sized left offsets from sideBar.css
                    '[&_ul]:!pl-0 [&_ul]:!ml-0 [&_ul]:w-full',
                    '[&_.sidebar-section]:!pl-0 [&_.sidebar-section]:!ml-0 [&_.sidebar-section]:w-full',
                    '[&_.sidebar-settings-children]:!pl-0 [&_.sidebar-settings-children]:!ml-0',
                    '[&_.sidebar-settings-children_ul]:!pl-3',
                    '[&_li]:!ml-0 [&_li]:!mr-0 [&_li]:w-full [&_li]:min-h-[48px]',
                    '[&_button]:!ml-0 [&_button]:!mr-0 [&_button]:w-full [&_button]:min-h-[48px]',
                    '[&_li]:!pl-3 [&_button]:!pl-3',
                  ].join(' ')
                : ''
            } ${roleName === 'agency' ? 'sidebar-navigation-agency' : ''}`}
          >
            {roleName === 'agency' ? (
              <>
                {/* Flat top-level items */}
                <ul className="sidebar-menu-list">
                  {topLevelItems.map(renderItem)}
                </ul>

                {/* Settings accordion with nested items */}
                <section className="sidebar-section">
                  <button
                    type="button"
                    className={`sidebar-settings-toggle ${isSettingsExpanded ? 'sidebar-settings-toggle-open' : ''} ${settingsIds.includes(selectedItem) ? 'sidebar-settings-toggle-active' : ''}`}
                    onClick={() =>
                      setIsSettingsExpanded((isExpanded) => !isExpanded)
                    }
                    aria-expanded={isSettingsExpanded}
                  >
                    <span className="sidebar-menu-icon material-symbols-outlined">
                      settings
                    </span>
                    <span className="sidebar-menu-label">Settings</span>
                    <span className="sidebar-settings-chevron material-symbols-outlined">
                      expand_more
                    </span>
                  </button>
                  <div
                    className={`sidebar-settings-children ${isSettingsExpanded ? 'sidebar-settings-children-open' : ''}`}
                  >
                    <ul className="sidebar-menu-list">
                      {settingsItems.map(renderItem)}
                    </ul>
                  </div>
                </section>
              </>
            ) : (
              <ul className="sidebar-menu-list sidebar-menu-list-legacy">
                {menuItems.map(renderItem)}
              </ul>
            )}
          </nav>
        )}
      </div>
    </div>
  );
}

function SidebarItem({
  item,
  selectedItem,
  hoveredItem,
  setHoveredItem,
  handleChangeMenu,
}) {
  const isActive = selectedItem === item.id || hoveredItem === item.id;

  return (
    <li
      onMouseEnter={() => setHoveredItem(item.id)}
      onMouseLeave={() => setHoveredItem(null)}
      onClick={() => handleChangeMenu(item.id)}
      className={`sidebar-menu-item ${isActive ? 'sidebar-menu-item-active' : ''}`}
    >
      <span
        className={`sidebar-menu-icon material-symbols-outlined ${isActive ? 'sidebar-menu-icon-active' : ''}`}
      >
        {item.icon ||
          (item.label === 'Dashboard'
            ? 'dashboard'
            : item.label === 'My Business'
              ? 'business'
              : 'person')}
      </span>
      <span className="sidebar-menu-label">{item.label}</span>
    </li>
  );
}

export default Sidebar;
